import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, IBookmakerApiListResponse, IBookmakerStopBettingAllResponse, IBookmakerUpdateParams } from '@/types';

export const bookmakerList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IBookmakerApiListResponse>> => {
    return axios.get('/api/bookmaker/list', { ...config, params });
};

export const bookmakerUpdate = (params: IBookmakerUpdateParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/bookmaker/update', params);
};

export const bookmakerStopBettingAll = (): Promise<AxiosResponse<IBookmakerStopBettingAllResponse>> => {
    return axios.post('/api/bookmaker/stopBettingAll');
};
